import { COLORS } from '@/constants';

export const directLinkTooltipSlotProps = {
  tooltip: {
    sx: {
      bgcolor: '#fff',
      color: COLORS['neutral/800'],
      fontSize: '12px',
      lineHeight: 1.5,
      padding: '10px 12px',
      borderRadius: '6px',
      boxShadow: '0px 2px 10px 0px #0000001A',
      maxWidth: 340,
    },
  },
};
